import styled from "styled-components";

export const PageWrapper = styled.div`
  padding: 40px 24px;
  background-color: #f2f2f4;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ProfileCard = styled.div`
  width: 100%;
  max-width: 900px;
  background: #ffffff;
  border: 1px solid #e5e5e7;
  border-radius: 8px;
  padding: 40px;
`;

export const DynamicSection = styled.div`
  margin-top: 32px;
  padding: 24px;
  background: #f9f9fb;
  border: 1px solid #e5e5e7;
  border-radius: 8px;

  .item-row {
    display: flex;
    gap: 12px;
    margin-bottom: 12px;
    align-items: flex-start;
    
    @media (max-width: 768px) {
      flex-direction: column;
    }
  }
`;

export const StyledForm = styled.div`
  .ant-form-item-label label {
    font-weight: 600;
    color: #1d1d1f;
  }

  .ant-input, .ant-input-affix-wrapper, .ant-select-selector {
    border-radius: 8px !important;
    border: 1px solid #d2d2d7 !important;
    padding: 8px 12px;
    
    &:hover, &:focus {
      border-color: #FF8F40 !important;
      box-shadow: none !important;
    }
  }

  .ant-input-disabled {
    background-color: #f5f5f7 !important;
    color: #86868b !important;
  }
`;